// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-manager .deactivateWidget .react-switch-bg {
  background: rgb(39, 83, 98) !important;
}

.widget-manager .react-switch-handle {
  background: #fff !important;
}

.page-body .widget-manager {
  margin-left: 0.5em;
  margin-right: 0.5em;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/widgetmanager.scss"],"names":[],"mappings":"AAAA;EACI,sCAAA;AACJ;;AACE;EACE,2BAAA;AAEJ;;AACE;EACE,kBAAA;EACA,mBAAA;AAEJ","sourcesContent":[".widget-manager .deactivateWidget .react-switch-bg{\n    background: rgb(39, 83, 98)  !important;\n  }\n  .widget-manager .react-switch-handle{\n    background: #fff !important;\n  \n  }\n  .page-body .widget-manager{\n    margin-left: 0.5em;\n    margin-right: 0.5em;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
